var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"upload-modal",attrs:{"name":"upload-modal","height":"auto","width":"350px","adaptive":true}},[_c('upload-status')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }